<template>
    <div class="my-revenueDetails">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow :fixed="true">
        </van-nav-bar>
        <van-tabs @click="onClick">
            <van-tab title="待结算"></van-tab>
            <van-tab title="已到账"></van-tab>
        </van-tabs>
        <Cxdate @chaxun="chaxun"/>
        <div >
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <div class="srmx-item" v-for="item in list">
                    <div class="srmx-item-top">
                        <span style="font-size: 10px">
<!--                        <span>订单编号: {{item.orderNo}}</span>-->
<!--                        <span v-if="item.lyType==1">销售</span>-->
<!--                        <span v-if="item.lyType==2">销售奖励</span>-->
<!--                        <span v-if="item.lyType==4">销售奖金</span>-->
<!--                        <span v-if="item.lyType==3">分润</span>-->
                            订单编号: {{item.orderNo}}
                        </span>
                        <span style="font-size: 10px;color:#B1AFB0;">{{item.createTime}}</span>
                    </div>
                    <div class="srmx-item-bottom">
                        <div class="srmx-item-val">
                            <span>收入</span>
                            <span>¥{{item.cmn}}</span>
                        </div>
                        <div class="srmx-item-val">
                            <span>状态</span>
                            <span>{{item.isSettlement==1?'已到账':'待结算'}}</span>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName} from "../../utils/auth";
    import Cxdate from "./../components/cxdate.vue";

    export default {
        components: {Cxdate},
        data() {
            return {
                title: '收入明细',
                deptId: '',
                token: '',
                member: {},

                active: 0,

                list: [],
                loading: false,
                finished: false,
                page: 1,
            };
        },
        async created() {
            document.title = getDeptName()
            this.deptId = getDeptId()
            this.token = getCookie("spmToken")
        },
        methods: {
            onClick(index) {
                this.active = index
                this.list = []
                this.page = 1
                this.loading = false
                this.finished = false
                this.onLoad()
            },
            chaxun(data) {
                this.dateType = data.dateType
                this.staDate = data.staDate
                this.endDate = data.endDate
                this.list = []
                this.page = 1
                this.loading = false
                this.finished = false
                this.onLoad()
            },
            async onLoad() {
                let currentPage = this.page || 1;
                let data = {
                    token: this.token,
                    staDate: this.staDate,
                    endDate: this.endDate,
                    dateType: this.dateType,
                    isSettlement: this.active,
                    currentPage
                }
                let res = await this.$get("/spm/getSpmRevenueDetails", data)
                if (res.code == 200) {
                    const count =res.list.length
                    const newList =res.list
                    const list =this.list.concat(newList)
                    if (list.length<30){
                        this.list = this.quchong(list,"id")
                    }else {
                        this.list =list
                    }
                    this.page=this.page+1
                    this.loading = false
                    if (count<10&&count==0){
                        this.finished = true
                    }
                }else {
                    this.finished = true
                }
            },
            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    .my-revenueDetails {
        margin: 0 auto;
        height: 100%;
        position: relative;
        background-color: #EEEEEE;
        padding-top: 46px;
    }

    .srmx-items {
        background-color: #EEEEEE;
    }

    .srmx-item {
        display: flex;
        flex-direction: column;
        background-color: #FFFFFF;
        margin: 5px;
        padding: 8px;
        height: 108px;
    }

    .srmx-item-top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 30px;
        line-height: 30px;
        padding: 0 12px;
    }

    .srmx-item-bottom {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 30px;
        line-height: 30px;
        margin-top: 15px;
    }

    .srmx-item-val {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0 12px;
    }

    .srmx-item-val span {
        width: 100px;
        font-size: 11px;
    }

</style>
